import { render, staticRenderFns } from "./TabelaResultadosTipoMandato.vue?vue&type=template&id=a96ca7a2&scoped=true&"
import script from "./TabelaResultadosTipoMandato.vue?vue&type=script&lang=js&"
export * from "./TabelaResultadosTipoMandato.vue?vue&type=script&lang=js&"
import style0 from "./TabelaResultadosTipoMandato.vue?vue&type=style&index=0&id=a96ca7a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a96ca7a2",
  null
  
)

export default component.exports